import { all, call, put, select, takeLatest } from 'redux-saga/effects'
import { GET_USER_FILES, SAVE_USER_FILE, UPLOAD_FILE } from 'store/types'
import CommonApi from 'api/common'
import { getUserFilesAction, saveUserFileAction, uploadFileAction } from 'store/actions/common'
import { get } from 'lodash'
import { getFileData } from 'utils/helper'
import { CustomFile } from 'types'

export function* uploadUserFile(files: CustomFile[] | FileList, isMultiple?: boolean) {
  const tenantId = yield select((state) => state.user.tenantId)

  // Convert FileList to array if needed, filter out invalid files, and ensure all files have the CustomFile structure
  const filesArray: CustomFile[] = (Array.isArray(files) ? files : Array.from(files))
    .filter((file) => file != null && file.name && file.type && file.size != null)
    .map((file) => {
      // If file already has invalid property, it's already a CustomFile
      if ('invalid' in file) {
        return file as CustomFile
      }
      // Otherwise, add the invalid property to make it a CustomFile
      // Use Object.assign to properly preserve File object properties
      return Object.assign(file, { invalid: false }) as CustomFile
    })

  if (filesArray.length === 0) {
    throw new Error('No valid files to upload')
  }

  const res = yield all(
    filesArray.map((file) => call(CommonApi.getSignedUrl, file.type, file.name))
  )
  const signedUrl = res.map((response) => JSON.parse(response.getSignedUrl.data))

  const data = yield all(
    filesArray.map((file, index) =>
      call(CommonApi.uploadFile, signedUrl[index].signedUrl, file, file.type)
    )
  )
  const clientId = yield select((state) => state.clients?.client?.profile?.id)
  const userId = yield select((state) => state.user?.user?.id)
  const id = clientId ? clientId : userId
  return getFileData({ data, files: filesArray, signedUrl, tenantId, userId: id, isMultiple })
}

function* uploadFile(action) {
  try {
    const { fileData } = yield uploadUserFile(action.payload?.files, action.payload?.isMultiple)

    if (action?.payload?.saveFile) {
      yield call(CommonApi.saveUserFile, {
        sendNotification: false,
        files: action.payload?.isMultiple ? fileData : [fileData],
      })
    }
    yield put(
      uploadFileAction.FULLFILLED({
        fileData,
      })
    )
  } catch (error: any) {
    console.log('errors : ', error.message)
    yield put(uploadFileAction.FULLFILLED({ uploadFileErrors: error.message }))
  }
}
function* getUserFiles(action) {
  const tenantId = yield select((state) => state.user.tenantId)

  const res = yield call(CommonApi.getUserFiles, action.payload.userId, tenantId)
  const data = JSON.parse(get(res, 'getUserFiles.data', ''))

  yield put(getUserFilesAction.FULLFILLED(data))
}
function* saveUserFile(action) {
  try {
    const tenantId = yield select((state) => state.user.tenantId)
    if (action?.payload?.generationNotification) {
      const filesData = yield select((state) => state.common?.uploadedFile)
      yield call(CommonApi.saveUserFile, { sendNotification: true, files: filesData })
      const payload = {
        userId: action.payload.userId,
      }
      yield call(getUserFiles, { payload })
    } else {
      const payload = { ...action.payload, tenantId }
      yield call(CommonApi.saveUserFile, { files: payload, sendNotification: false })
    }
    yield put(saveUserFileAction.FULLFILLED(action.payload))
  } catch (error) {
    console.log('Could not save file:', error)
    yield put(saveUserFileAction.REJECTED())
  }
}

/// /////////// Watchers ///////////////////////
export function* watcherCommon() {
  yield takeLatest(UPLOAD_FILE.STARTED, uploadFile)
  yield takeLatest(SAVE_USER_FILE.STARTED, saveUserFile)
  yield takeLatest(GET_USER_FILES.STARTED, getUserFiles)
}
